import Apiaxios from '../api/endpoints.js'
import { OK, INTERNAL_SERVER_ERROR } from '../util.js'
import Vue from 'vue'

const state = {
  apiStatus: null,
  errorMessages: null,
  tasks: [],        //一覧用配列
  task: null,       //編集、印刷
  complete: false,
}

const getters = {
  task_logs: state => {
    if(!state.task){
      return {
        task:{},
        task_log:{},
        select:{},
        logs:{
          img_log:{},
          task_log:{},
        },
      }
    }else{
      state.task.task_log.forEach( el => {
        Vue.set(el, 'select', false)
      })
      return state.task
    }
  },
  photos: state => {
    if(!state.task) return {}
    let dist = [[]]
    state.task.img_list.forEach( el => {
      let tail = dist.length - 1;
      dist[tail].push(el);
      if (dist[tail].length > 3 - 1)
        dist.push([]);
    });
    return dist
  }
}

const mutations = {
  setApiStatus(state, status){
    state.apiStatus = status
  },
  setErrorMessages(state, messages){
    state.errorMessages = messages
  },
  setTasks(state, tasks){
    state.tasks.push(...tasks)
  },
  setTask(state, task){
    state.task = task
  },
  setComplete(state, complete){
    state.complete = complete
  },
  clearTasks(state){
    state.tasks = []
  }
}

const actions = {
  /**
  * タスク一覧取得
  */
  async getTaskList(context, data){

    context.commit('setApiStatus', null)
    context.commit('setErrorMessages', null)
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots' }, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']

    await Apiaxios.getTaskList(data).then(response => {
      if (response.status === OK) {
        context.commit('setApiStatus', true)
        if(response.data.length === 0){
          //表示するものがない場合
          context.commit('setComplete', true)
        }else{
          //表示するものがある場合
          context.commit('setTasks', response.data)
          context.commit('setComplete', false)
        }
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください")
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log("err",error);
      context.commit('setApiStatus', false)
      context.commit('setComplete', true)

      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      }else{
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * 個別タスクの取得
   * @param {*} context 
   * @param {*} data 
   */
  async getTask(context, data){
    context.commit('setApiStatus', null)
    context.commit('setErrorMessages', null)
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots' }, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']
    await Apiaxios.getTask(data).then(response => {
      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('setTask', response.data)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください")
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log("err",error);
      context.commit('setApiStatus', false)

      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      }else{
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * タスクの編集
   * @param {*} context 
   * @param {*} data 
   */
  async editTask(context, data){
    context.commit('setApiStatus', null)
    context.commit('setErrorMessages', null)
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots' }, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']
    await Apiaxios.editTask(data).then(response => {
      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください")
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log("err",error);
      context.commit('setApiStatus', false)

      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      }else{
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * タスクのタイトルと詳細の編集
   * @param {*} context 
   * @param {*} data 
   */
  async taskTitleUpdate(context, data){
    context.commit('setApiStatus', null)
    context.commit('setErrorMessages', null)
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots' }, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']
    await Apiaxios.updateTask(data).then(response => {
      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください")
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log("err",error);
      context.commit('setApiStatus', false)

      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      }else{
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  async newTask(context, data){
    context.commit('setApiStatus', null)
    context.commit('setErrorMessages', null)
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots' }, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']
    await Apiaxios.newTask(data).then(response => {
      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください")
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log("err",error);
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      }else{
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  clearTasks(context){
    //履歴を削除
    context.commit('clearTasks')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}